function addEvents() {
    var buttons = document.querySelectorAll("a[data-trigger], button[data-trigger]");

    for (const button of buttons) {
        button.addEventListener("click", function (event) {
            event.preventDefault();

            var dataAttributeValue = this.dataset.trigger;

            var interactionElements = document.querySelectorAll('.interaction-layer[data-trigger = ' + dataAttributeValue + ']');
            for (const interactionElement of interactionElements) {
                interactionElement.classList.add("active")
            }

            var body = document.body;
            body.classList.add("interaction-layer-active");
        });
    }

    var closeButtons = document.querySelectorAll(".dismiss");

    for (const closeButton of closeButtons) {
        closeButton.addEventListener("click", function (event) {
            event.preventDefault();

            var body = document.body;
            body.classList.remove("interaction-layer-active");

            var interactionElements = document.querySelectorAll('.interaction-layer[data-trigger]');
            for (const interactionElement of interactionElements) {

                interactionElement.classList.remove("active");
            }
        });
    }
}

//document ready in plain javascript
if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
    addEvents();
} else {
    document.addEventListener("DOMContentLoaded", addEvents);
}